import React from 'react';
import { TableCell, WithStyles } from '@material-ui/core';
import styles from './styles';
import { TopThreeReportRank } from '../../types/report';

type Props = {
  values: TopThreeReportRank[];
} & WithStyles<typeof styles>;

const TopThreeReportCell: React.FC<Props> = (props) => {
  const {
    values,
    classes,
  } = props;

  return (
    <TableCell align="center" className={classes.cell}>
      {(values || []).map(({ value, count }, index) => (
        <div key={value} className={classes.rank}>
          {`${index + 1}. ${value} (${count})`}
        </div>
      ))}
    </TableCell>
  );
};

export default React.memo(TopThreeReportCell);
